// Material Kit 2 React pages
import Books from "pages/LandingPages/Books";

export default function BooksPage() {
  return <Books />;
}
